<template>
  <div class="flex flex-col py-3 px-3 w-full overflow-x">
    <span
      v-if="getTextFromHtml(props.value)?.trim()"
      class="text-sm text_color break-all line-clamp-2 overflow-hidden"
    >
      {{ getTextFromHtml(props.value).trim() }}
    </span>
    <span
      v-else
      class="text-sm secondary_color break-all line-clamp-2 overflow-hidden"
    >
      No Note Added
    </span>

    <span class="mt-1 text-xs" v-if="sequence">
      <span class="font-semibold text_color" v-if="sequence.name">
        {{ sequence.step }} of
      </span>
      <span class="font-semibold text_color" v-if="sequence.step">
        {{ sequence.name }}
      </span>
    </span>
  </div>
</template>
<script setup>
import { defineProps, computed } from "vue";
import { getTextFromHtml } from "../../../utils/htmlUtils.js";

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  row: {
    type: Object,
    default: () => ({}),
  },
});

const sequence = computed(() => {
  if (props.row.sequence_name || props.row.sequence_step) {
    return {
      name: props.row.sequence_name,
      step: props.row.sequence_step,
    };
  }
  return null;
});
</script>
